import classNames from 'classnames';
import React from 'react';
import {
	Link,
} from 'react-router5';

import useUrlState from '~/hooks/useUrlState';

import useNavigationLinkClick from '~/hooks/useNavigationLinkClick';

import {
	type RenderProp,
	renderProp,
} from '~/utilities/renderProp';



type ChildProps = {
	isActive: boolean,
	isDimmed: boolean,
};

type Props = {
	children: RenderProp<ChildProps>,
	className?: string,
	onClick?: () => void,
	accountId?: number | null,
};

const AccountLink: React.FC<Props> = (props) => {
	const {
		children,
		className,
		onClick,
		accountId,
	} = props;

	const urlState = useUrlState();

	const isActive = urlState.name.startsWith('account.');

	const handleClick = useNavigationLinkClick(onClick);

	const finalClassName = classNames({
		'active': isActive,
	}, className);

	return (
		<Link
			className={finalClassName}
			onClick={handleClick}
			routeName="account.websites"
			routeParams={{
				accountId: accountId ?? undefined,
			}}
		>
			{renderProp(
				children,
				{
					isActive,
					isDimmed: false,
				},
			)}
		</Link>
	);
};



export default AccountLink;
